'use strict';
var fails = require('../internals/fails');

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal
    method.call(null, argument || function () { throw 1; }, 1);
  });
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/~/core-js/internals/array-method-is-strict.js
// module id = 107
// module chunks = 0